import { OrderMediaCreateCategoryEnum } from '@insurance/api/requests'
import { AddOrderMediaFields, OrderMedia } from '@insurance/components'
import { Text } from '@shared/components'
import { Flex } from 'antd'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  orderId?: string | number
  categories?: OrderMediaCreateCategoryEnum[]
  categoryLabelKey?: Record<string, string>
}

export const OrderMediaActions = ({
  orderId,
  categories,
  categoryLabelKey
}: Props) => {
  const { t } = useTranslation()
  const [disabledFileGet, setDisabledFileGet] = useState(false)

  return (
    <>
      <Flex align="center" gap={8} justify="space-between">
        <Text size={16} strong>
          {t('attachment_files')}
        </Text>
      </Flex>

      <OrderMedia
        orderId={orderId}
        disabledFileGet={disabledFileGet}
        categoryLabelKey={categoryLabelKey}
      />

      <AddOrderMediaFields
        orderId={orderId}
        categories={categories}
        categoryLabelKey={categoryLabelKey}
        onDisabledFileGet={setDisabledFileGet}
      />
    </>
  )
}
